import React from "react";
import { useTranslation } from "react-i18next";
import { Body2 } from "@activecollab/components";

const PrePaidPaymentMethodInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="tw-grid tw-grid-cols-[200px_auto] tw-gap-2">
      <Body2
        color="primary"
        weight="bold"
      >
        {t("Payment Type")}
      </Body2>
      <Body2 color="tertiary">Custom Order Payment</Body2>
    </div>
  );
};

export default PrePaidPaymentMethodInfo;
